'use client'

import { Article, HeroSimple, Heading, Paragraph, Button, ButtonTitle } from '@systhemaui/next'

export default function Error({
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <Article theme="default">
      <HeroSimple alignContent="center">
        <Heading.h1>Valami hiba történt!</Heading.h1>
        <Paragraph type="lead" className="text-balance">
          Kérjük, próbáld újra később.
        </Paragraph>
        <div className="mt-4">
          <Button onClick={() => reset()}>
            <ButtonTitle>Újrapróbálás</ButtonTitle>
          </Button>
        </div>
      </HeroSimple>
    </Article>
  )
}
